import { useContext } from 'react';
import { AuthContext } from '../contexts/auth';
import { ProxyLoginContext } from '../contexts/ProxyLoginContext';

type UseCompanyIdReturn = {
  companyId: string | null;
  isProxyMode: boolean;
  operatorId: string | null;
  operatorRole: number | null;
};

/**
 * 代理モードを考慮して適切な company_id を返すフック
 * 代理モード中は targetCompanyId、通常は user.company_id を返す
 */
export const useCompanyId = (): UseCompanyIdReturn => {
  const { user } = useContext(AuthContext);
  const { isProxyLogin, targetCompanyId, operatorId, operatorRole } = useContext(ProxyLoginContext);

  const companyId = isProxyLogin && targetCompanyId ? targetCompanyId : (user?.company_id ?? null);

  return {
    companyId,
    isProxyMode: isProxyLogin,
    operatorId: isProxyLogin ? operatorId : null,
    operatorRole: isProxyLogin ? operatorRole : null,
  };
};
